import React from "react";
import InputBaseWithErrorLabel from "./InputBaseWithErrorLabel";
import { useValidate } from "formvalidation/hooks";
import { useSemanticUiInputRef } from "utilities/hookutils";
import { CommonInputProps } from "./models";


const FirstNameInput = (props: CommonInputProps) => {
  const { validatorKey, ...rest } = props;
  const semanticInputRef = useSemanticUiInputRef();

  const validateFirstName = async () => {
    if (props.value.trim().length === 0) {
      return RESX.GeneralWarnings.PleaseFillInThisField;
    }

    return true;
  };

  const validation = useValidate({
    key: validatorKey,
    title: RESX.Contact.FirstName,
    value: props.value,
    validate: validateFirstName,
    ref: semanticInputRef.ref
  });

  return <InputBaseWithErrorLabel
    {...rest}
    innerRef={semanticInputRef.refSetter}
    error={validation.error.errorMessage ?? validation.error.hasError}
    maxLength={serverReference.constants.personName.maxFirstNameLength}
    placeholder={RESX.Contact.FirstName}
    fluid
  />
};

export default FirstNameInput;